/** F1 team colors for charts */
export const TEAM_COLORS: Record<string, string> = {
  'McLaren': '#FF8000',
  'Red Bull': '#3671C6',
  'Ferrari': '#E8002D',
  'Mercedes': '#27F4D2',
  'Aston Martin': '#229971',
  'Alpine': '#FF87BC',
  'Williams': '#64C4FF',
  'RB': '#6692FF',
  'Haas': '#B6BABD',
  'Sauber': '#52E252',
};

export const CURRENT_YEAR = new Date().getUTCFullYear();
